// frontend/src/utils/fcm.js
import { getMessagingInstance, getToken } from "../firebase-messaging";
import axios from "../axios";
import { toast } from "react-toastify";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "";

export const registerFcmToken = async (userId, force = false) => {
  try {
    if (typeof Notification === "undefined") {
      console.warn("⚠️ API Notification non disponible sur cet appareil");
      return;
    }
    const permission = await Notification.requestPermission();
    console.log("🔍 Permission notifications :", permission);

    // 🚫 Si l’utilisateur n’a pas accordé les notifications
    if (permission !== "granted") {
      console.warn("🔕 Notifications refusées");
      return;
    }

    // ⚠️ Si on ne force pas, on vérifie le statut stocké avant d’enregistrer
    const user = JSON.parse(localStorage.getItem("user")) || {};
    if (!force && user.subscribedToPush !== true) {
      console.log("⏸️ Utilisateur non abonné — on ne crée pas le token automatiquement");
      return;
    }

    const messagingInstance = getMessagingInstance();
    if (!messagingInstance) return;
    const fcmToken = await getToken(messagingInstance, {
      vapidKey: "BBGKXZTNZYudlq-1Byuovg-i0ikbgmZBd12ZeIYMsHA8I0lbIfOo7UrVjUInsgkdnKdBwXzcjie8ke1-Rp8KICY",
    });

    if (!fcmToken) {
      console.warn("⚠️ Aucun token FCM généré");
      return;
    }

    console.log("✅ Token FCM généré :", fcmToken);

    // ✅ Empêcher les doublons
    if (localStorage.getItem("lastFcmToken") === fcmToken) {
      console.log("ℹ️ Token identique, pas de toast ni nouvel envoi");
      return;
    }
    localStorage.setItem("lastFcmToken", fcmToken);

    // ✅ Envoi unique au backend
    const res = await axios.put(`/auth/update-push`, {
      userId,
      fcmToken,
      subscribedToPush: true,
    });

    console.log("📡 Token enregistré côté serveur :", res.data);
    toast.success("🔔 Identifiant d’appareil enregistré");
  } catch (err) {
    console.error("❌ Erreur lors de l'enregistrement du token FCM :", err);
    console.warn("⚠️ FCM non disponible sur ce domaine — notifications désactivées");
  }
};
